import { Modal } from "react-bootstrap";
import ModalHead from "../../../../common/ui/ModalHead";

/* The products a voucher can be spent on.

   ⚠ data-productid is read by handleSelectProductItemVoucherProductList off
   currentTarget, so it stays on the button; inner markup is free.

   ⚠ voucherMenu<N> is looked up by name off OriginalData — the group's
   VoucherMenuNumber builds the key. Leave that lookup alone.

   No placeholder graphic: a product with no photo gets a text-only row rather
   than a grey box, matching the main menu's behaviour. */
export default function ItemVoucherProductListPage(props) {
    let voucherMenuNumber = `voucherMenu${props.loyaltyMember.ItemVoucherProductListPage.SelectedGroup.VoucherMenuNumber}`;
    let groupDetails = props.loyaltyMember.VoucherDetails.OriginalData[voucherMenuNumber][0];
    let productsInGroup = groupDetails.products;

    // Map Products
    let productList = productsInGroup.map((item) => {

        let energyCount;
        if (item.energyCount !== 0 && item.energyCount !== "0" && item.energyCount !== "" && item.energyCount !== null) {
            energyCount = <span className="wo-pm__kj">{item.energyCount}kJ</span>
        } else {
            energyCount = <></>
        }

        return (
            <button type="button"
                className="wo-vprod"
                key={item.productID}
                data-productid={item.productID}
                onClick={props.handleSelectProductItemVoucherProductList}
            >
                {/* Always rendered — see the note in ProductComboListModalProduct. */}
                <span className={`wo-vprod__thumb${item.productImageURL ? '' : ' wo-vprod__thumb--empty'}`}>
                    {item.productImageURL
                        ? <img src={item.productImageURL} alt="" loading="lazy" decoding="async" />
                        : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"
                               strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <rect x="3" y="4.5" width="18" height="15" rx="2.5" />
                            <circle cx="8.5" cy="10" r="1.6" />
                            <path d="M21 15.5l-4.6-4.3a1.6 1.6 0 0 0-2.2 0L5 19.5" />
                          </svg>}
                </span>
                <span className="wo-vprod__text">
                    <span className="wo-vprod__nameRow">
                        <span className="wo-vprod__name">{item.productDisplayName}</span>
                        {energyCount}
                    </span>
                    {item.productDescription && <span className="wo-vprod__desc">{item.productDescription}</span>}
                </span>
            </button>
        )
    })

    return (
        <>
            <ModalHead
                title="Choose an item"
                onBack={props.handleBackItemVoucherProductList}
                backDisabled={props.loyaltyMember.ItemVoucherProductListPage.GeneralError.ButtonsDisabled}
                onClose={props.handleClickCloseLoyaltyModal}
            />
            <Modal.Body className="wo-loy__body">
                <div className="wo-vprod__list">
                    {productList}
                </div>
            </Modal.Body>
        </>
    )
}
